import type { Application } from '../types/applications'

export const isMongoDBApplicationEligible = (
	application: Application | null | undefined
): application is Application =>
	application != null &&
	application.status === 'APPROVED' &&
	application.details?.addOns?.mongodb === true